module.exports = __webpack_public_path__ + "static/img/income1.b3ee8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/income1.png
// module id = ir7P
// module chunks = 2